export default "__VITE_ASSET__DsLZAQp2__"